export const EmailState = Object.freeze({
  empty: 'EMAIL.EMPTY',
  empty_resend: 'EMAIL.EMPTY_RESEND',
  valid: 'EMAIL.VALID',
  invalid: 'EMAIL.INVALID',
  notAvailable: 'EMAIL.NOT_AVAILABLE',
  checking: 'EMAIL.CHECKING',
  blocked: 'EMAIL.BLOCKED'
})

export default {
  data () {
    return {
      /**
       * current state of the email
       */
      emailState: EmailState.empty,
      /**
       * Is true id the email is valid
       */
      emailValid: true,
    }
  },
  methods: {
    /**
     * Check if the email syntax valid.
     * If is valid check if the emial already exsist
     * @param email
     */
    validateEmail (email) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (emailRegex.test(email)) {
        return this.checkEmailIsValid(email)
      } else {
        this.emailState = EmailState.invalid
        this.emailValid = false
        return new Promise(resolve => resolve())
      }
    },
    /**
     * Check if the email syntax valid.
     * If is valid check if the emial already exsist
     * @param email
     */
    validateEmailAndCheckExisting (email) {
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (emailRegex.test(email)) {
        return this.checkEmailIsValid(email)
      } else {
        this.emailState = EmailState.invalid
        this.emailValid = false
        return new Promise(resolve => resolve())
      }
    },
    /**
     * check at the api if the Email already exist
     * Sets the
     * @param value
     */
    checkEmailIsValid (value) {
      this.emailState = EmailState.checking
      this.emailValid = false

      return this.requestValidateEmail(value)
        .then((response) => {
          if (response.state) this.emailState = EmailState.valid
          else this.emailState = EmailState.notAvailable
          this.emailValid = response.state
        })
        .catch((httpResponse) => {
          if (!httpResponse.ok) {
            if (httpResponse.body.data && httpResponse.body.data.formErrors) {
              this.handleFormErrors(httpResponse.body.data.formErrors);
            } else {
              this.emailState = EmailState.notAvailable
              this.emailValid = false
            }
          }
        })
    },
    setEmailBlocked () {
      this.emailState = EmailState.blocked
      this.emailValid = false
    },
    setEmailUnavailable () {
      this.emailState = EmailState.notAvailable
      this.emailValid = false
    },
    setEmailInvalid () {
      this.emailState = EmailState.invalid
      this.emailValid = false
    },

    handleFormErrors (formErrors) {
      if (formErrors.email) {
        formErrors.email.forEach((errorCode) => {
          switch (errorCode) {
            case 'email_blocked':
              this.setEmailBlocked()
              break
            case 'email_already_taken':
              this.setEmailUnavailable()
              break
            case 'email_invalid':
              this.setEmailInvalid()
              break
          }
        })
      }
    }
  }
}
